import { z } from 'zod';
import { sessionStorageKeys } from '@/constants/sessionStorageKeys';

const environmentSchema = z
  .object({
    VITEST: z.enum(['true', 'false']).optional(),
    VITE_API_ROOT: z.url(),
    VITE_API_ROOT_SUFFIX: z.string().optional(),
    VITE_COUNTRY: z.enum(['SE', 'UK', 'FI']),
    VITE_ENV: z.enum(['local', 'develop', 'test', 'staging', 'sandbox', 'production']),
    VITE_DVC_SDK_KEY: z.string(),
    VITE_LOQATE_KEY: z.string(),
    VITE_MARKETING_SITE_URL: z.url(),
    VITE_FRESHDESK_KEY: z.string(),
    VITE_SANITY_PROJECT_ID: z.string(),
    VITE_SANITY_DATASET: z.string(),
    VITE_SANITY_API_TOKEN: z.string().optional(),
    VITE_SANITY_API_VERSION: z.string(),
    VITE_POSTHOG_KEY: z.string(),
    VITE_POSTHOG_API_HOST: z.string(),
    VITE_POSTHOG_UI_HOST: z.string(),
    VITE_GTM_CONTAINER_ID: z.string(),
    VITE_VERSION: z.string(),
    VITE_TRANSUNION_DEVICE_SUBKEY: z.string().optional(),
  })
  .transform(env => ({
    isTesting: env.VITEST === 'true',
    apiRoot: env.VITE_API_ROOT,
    apiRootSuffix: env.VITE_API_ROOT_SUFFIX ?? '',
    country: env.VITE_COUNTRY,
    dvcSdkKey: env.VITE_DVC_SDK_KEY,
    env: env.VITE_ENV,
    freshdeskKey: env.VITE_FRESHDESK_KEY,
    loqateKey: env.VITE_LOQATE_KEY,
    marketingSiteUrl: env.VITE_MARKETING_SITE_URL,
    sanityProjectId: env.VITE_SANITY_PROJECT_ID,
    sanityDataset: env.VITE_SANITY_DATASET,
    sanityApiToken: env.VITE_SANITY_API_TOKEN,
    sanityApiVersion: env.VITE_SANITY_API_VERSION,
    posthogKey: env.VITE_POSTHOG_KEY,
    posthogApiHost: env.VITE_POSTHOG_API_HOST,
    posthogUiHost: env.VITE_POSTHOG_UI_HOST,
    gtmContainerId: env.VITE_GTM_CONTAINER_ID,
    version: env.VITE_VERSION,
    transunionDeviceSubkey: env.VITE_TRANSUNION_DEVICE_SUBKEY,
  }));

export const environment = environmentSchema.parse(import.meta.env);

export const isMockingEnabled = () => {
  if (environment.env !== 'local') {
    return false;
  }
  return sessionStorage.getItem(sessionStorageKeys.DEVTOOLS_MSW_ENABLED) === 'true';
};
